import { ConfigStore } from "../../Stores";
export function storeToken(token) {
    ConfigStore.config.connections.jwt = token;
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        window["__token__"] = token;
    }
}
//# sourceMappingURL=StoreToken.js.map